export const acceptedTypes = ["txt", "xlsx"];

export const isValidFileType = (fileType) => {
  return acceptedTypes.includes(fileType);
};
